import PageTitle from '@components/PageTitle'
import PageWithRightSidebarTpl from '@components/PageWithRIghtSidebarTpl'
import WithPortalAuthorization from '@hocs/WithPortalAuthorization'
import ScheduleOptions from '@layouts/Scheduling/ScheduleOptions'
import SchedulingLayout from '@layouts/Scheduling/SchedulingLayout'
import React from 'react'

const Scheduling: React.FunctionComponent = () => (
  <>
    <PageTitle title={'Scheduling'} />
    <PageWithRightSidebarTpl
      body={
        <SchedulingLayout activeTab={1}>
          <ScheduleOptions />
        </SchedulingLayout>
      }
      sidebar={<></>}
      showSidebar={false}
    />
  </>
)

export default WithPortalAuthorization(Scheduling, {
  id: 'page::scheduling',
})
